export const CalendarNotification = () => (
  <svg
    width="288"
    height="167"
    viewBox="0 0 288 167"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity="0.24"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.5 125.799C0.5 136.394 9.43609 146.048 24.1411 153.345C41.0109 161.718 65.4739 166.982 92.7422 167C104.66 167.007 116.055 166.007 126.522 164.18C131.933 163.234 137.991 163.343 143.232 164.463C149.381 165.774 156.266 166.51 163.536 166.51C166.539 166.51 169.48 166.383 172.325 166.143C180.445 165.461 187.835 163.846 193.904 161.559C197.717 160.121 202.602 159.398 207.594 159.4H207.679C224.175 159.4 239.498 157.169 252.219 153.345C263.592 149.93 272.88 145.245 279.068 139.743C284.463 134.948 287.5 129.532 287.5 123.8C287.5 104.14 251.76 88.2003 207.679 88.2003C203.185 88.2003 198.783 88.3696 194.487 88.6855C183.114 80.474 162.748 75 139.515 75C129.706 75 120.406 75.9756 112.082 77.7245C104.166 79.3823 97.1279 81.738 91.3704 84.6089C71.8203 84.7479 53.7433 87.5963 38.9478 92.35C15.658 99.8286 0.5 112.025 0.5 125.799Z"
      fill="url(#paint0_linear_12640_41672)"
      fillOpacity="0.25"
    />
    <g clipPath="url(#clip0_12640_41672)">
      <path
        d="M79.4336 65.7329V120.926C79.4336 133.05 89.2618 142.879 101.386 142.879H186.616C198.741 142.879 208.569 133.05 208.569 120.926V65.7329H79.4336Z"
        fill="#CCCFF2"
      />
      <path
        d="M208.58 50.8892V112.598C208.58 124.731 198.729 134.557 186.622 134.557H101.38C89.2729 134.557 79.4219 124.731 79.4219 112.598V50.8892H208.58Z"
        fill="#E9E7FC"
      />
      <path
        d="M208.569 54.5754V41.3055C208.569 29.1817 198.74 19.353 186.617 19.353H101.386C89.2622 19.353 79.4336 29.1817 79.4336 41.3055V54.5754H208.569Z"
        fill="url(#paint1_linear_12640_41672)"
      />
      <path
        d="M208.569 50.8938V37.6238C208.569 25.5 198.74 15.6714 186.617 15.6714H101.386C89.2622 15.6714 79.4336 25.5 79.4336 37.6238V50.8938H208.569Z"
        fill="#0B70E1"
      />
      <path
        d="M117.34 63.5229H96.2658C93.9402 63.5229 92.0547 65.4082 92.0547 67.7341V84.7067C92.0547 87.0323 93.9402 88.9178 96.2658 88.9178H117.34C119.665 88.9178 121.551 87.0323 121.551 84.7067V67.7341C121.551 65.4082 119.665 63.5229 117.34 63.5229Z"
        fill="white"
      />
      <path
        d="M154.539 63.5229H133.375C131.05 63.5229 129.164 65.4082 129.164 67.7341V84.7067C129.164 87.0323 131.05 88.9178 133.375 88.9178H154.539C156.864 88.9178 158.75 87.0323 158.75 84.7067V67.7341C158.75 65.4082 156.864 63.5229 154.539 63.5229Z"
        fill="white"
      />
      <path
        d="M191.734 63.5229H170.571C168.245 63.5229 166.359 65.4082 166.359 67.7341V84.7067C166.359 87.0323 168.245 88.9178 170.571 88.9178H191.734C194.06 88.9178 195.945 87.0323 195.945 84.7067V67.7341C195.945 65.4082 194.06 63.5229 191.734 63.5229Z"
        fill="white"
      />
      <path
        d="M117.34 96.5288H96.2658C93.9402 96.5288 92.0547 98.4141 92.0547 100.74V117.713C92.0547 120.038 93.9402 121.924 96.2658 121.924H117.34C119.665 121.924 121.551 120.038 121.551 117.713V100.74C121.551 98.4141 119.665 96.5288 117.34 96.5288Z"
        fill="white"
      />
      <path
        d="M101.612 81.8924L97.7143 75.9104C97.0215 74.8466 97.3278 73.4314 98.4021 72.7494C99.4698 72.0694 100.904 72.3804 101.601 73.4471L103.937 77.0343L112.303 68.7239C113.205 67.8283 114.67 67.8283 115.578 68.7239C116.485 69.6193 116.489 71.0695 115.588 71.9643L105.196 82.2783C104.162 83.3055 102.416 83.1292 101.612 81.8924Z"
        fill="#CCCFF2"
      />
      <path
        d="M138.819 81.8924L134.921 75.9104C134.229 74.8466 134.535 73.4314 135.609 72.7494C136.677 72.0694 138.112 72.3804 138.808 73.4471L141.144 77.0343L149.51 68.7239C150.412 67.8283 151.877 67.8283 152.785 68.7239C153.692 69.6193 153.696 71.0695 152.795 71.9643L142.403 82.2783C141.369 83.3055 139.623 83.1292 138.819 81.8924Z"
        fill="#CCCFF2"
      />
      <path
        d="M176.022 81.8924L172.124 75.9104C171.432 74.8466 171.738 73.4314 172.812 72.7494C173.88 72.0694 175.315 72.3804 176.012 73.4471L178.347 77.0343L186.713 68.7239C187.615 67.8283 189.08 67.8283 189.988 68.7239C190.895 69.6193 190.9 71.0695 189.998 71.9643L179.607 82.2783C178.572 83.3055 176.826 83.1292 176.022 81.8924Z"
        fill="#CCCFF2"
      />
      <path
        d="M101.612 115.618L97.7143 109.636C97.0215 108.573 97.3278 107.158 98.4021 106.475C99.4698 105.796 100.904 106.106 101.601 107.173L103.937 110.76L112.303 102.45C113.205 101.554 114.67 101.554 115.578 102.45C116.485 103.345 116.489 104.796 115.588 105.69L105.196 116.004C104.162 117.032 102.416 116.855 101.612 115.618Z"
        fill="#CCCFF2"
      />
      <path
        d="M203.929 112.598C205.802 122.163 196.189 131.788 186.621 129.906C195.717 128.336 202.369 121.699 203.929 112.598Z"
        fill="white"
      />
      <path
        d="M208.569 37.6237C208.569 29.1263 203.733 21.7717 196.67 18.123C196.952 34.6524 173.456 47.3688 131.5 50.8936H208.569V37.6237Z"
        fill="#0B70E1"
      />
      <path
        d="M115.939 31.1499C115.939 35.6357 112.309 39.2657 107.822 39.2657C103.336 39.2657 99.707 35.6357 99.707 31.1499C99.707 26.6638 103.336 23.0337 107.822 23.0337C112.309 23.0337 115.939 26.6638 115.939 31.1499Z"
        fill="#0B70E1"
      />
      <path
        d="M111.07 9.47122C111.9 10.3015 112.419 11.4436 112.419 12.7103V31.1475C112.419 33.6805 110.364 35.736 107.831 35.736C105.298 35.736 103.242 33.6805 103.242 31.1475V12.7103C103.242 10.1768 105.298 8.12158 107.831 8.12158C109.097 8.12158 110.24 8.64065 111.07 9.47122Z"
        fill="url(#paint2_linear_12640_41672)"
      />
      <path
        d="M152.118 31.1499C152.118 35.6357 148.488 39.2657 144.002 39.2657C139.516 39.2657 135.887 35.6357 135.887 31.1499C135.887 26.6638 139.516 23.0337 144.002 23.0337C148.488 23.0337 152.118 26.6638 152.118 31.1499Z"
        fill="#0B70E1"
      />
      <path
        d="M147.246 9.47122C148.076 10.3015 148.595 11.4436 148.595 12.7103V31.1475C148.595 33.6805 146.539 35.736 144.006 35.736C141.473 35.736 139.418 33.6805 139.418 31.1475V12.7103C139.418 10.1768 141.473 8.12158 144.006 8.12158C145.273 8.12158 146.415 8.64065 147.246 9.47122Z"
        fill="url(#paint3_linear_12640_41672)"
      />
      <path
        d="M188.294 31.1499C188.294 35.6357 184.664 39.2657 180.178 39.2657C175.692 39.2657 172.062 35.6357 172.062 31.1499C172.062 26.6638 175.692 23.0337 180.178 23.0337C184.664 23.0337 188.294 26.6638 188.294 31.1499Z"
        fill="url(#paint4_linear_12640_41672)"
      />
      <path
        d="M183.425 9.47122C184.256 10.3015 184.775 11.4436 184.775 12.7103V31.1475C184.775 33.6805 182.719 35.736 180.186 35.736C177.653 35.736 175.598 33.6805 175.598 31.1475V12.7103C175.598 10.1768 177.653 8.12158 180.186 8.12158C181.453 8.12158 182.595 8.64065 183.425 9.47122Z"
        fill="url(#paint5_linear_12640_41672)"
      />
      <g clipPath="url(#clip1_12640_41672)">
        <path
          d="M194.028 148H193.99C190.653 148 187.938 145.284 187.938 141.947V140.532C187.938 139.707 188.606 139.038 189.432 139.038H198.587C199.412 139.038 200.081 139.707 200.081 140.532V141.947C200.081 145.284 197.366 148 194.028 148Z"
          fill="#FF927C"
        />
        <path
          d="M198.59 139.038H194.012V148H194.031C197.368 148 200.084 145.284 200.084 141.947V140.532C200.084 139.707 199.415 139.038 198.59 139.038Z"
          fill="#EE4725"
        />
        <path
          d="M196.995 106.339H191.021C190.196 106.339 189.527 105.67 189.527 104.845V101.482C189.527 99.0114 191.537 97.0015 194.008 97.0015C196.479 97.0015 198.489 99.0115 198.489 101.482V104.845C198.489 105.67 197.82 106.339 196.995 106.339Z"
          fill="#FFA81C"
        />
        <path
          d="M196.998 106.339C197.823 106.339 198.492 105.67 198.492 104.845V101.482C198.492 99.0114 196.482 97.0015 194.012 97.0015V106.339H196.998Z"
          fill="#FF9300"
        />
        <path
          d="M209.842 142.026H178.177C176.884 142.026 175.832 140.974 175.832 139.681V137.545C175.832 135.205 176.694 132.958 178.258 131.218C179.328 130.027 179.918 128.49 179.918 126.889V117.209C179.918 109.439 186.239 103.118 194.009 103.118C201.78 103.118 208.101 109.439 208.101 117.209V126.889C208.101 128.49 208.691 130.027 209.761 131.218C211.325 132.958 212.187 135.205 212.187 137.545V139.681C212.187 140.974 211.135 142.026 209.842 142.026Z"
          fill="#FF927C"
        />
        <path
          d="M209.844 142.026C211.137 142.026 212.189 140.974 212.189 139.681V137.545C212.189 135.205 211.328 132.958 209.763 131.218C208.693 130.027 208.103 128.49 208.103 126.889V117.209C208.103 109.439 201.782 103.118 194.012 103.118V142.026H209.844Z"
          fill="#EE4725"
        />
        <path
          d="M175.832 137.545V139.681C175.832 140.974 176.884 142.027 178.177 142.027H209.842C211.135 142.027 212.187 140.974 212.187 139.681V137.545C212.187 136.52 212.022 135.514 211.705 134.559H176.315C175.997 135.514 175.832 136.52 175.832 137.545Z"
          fill="#FFF566"
        />
        <path
          d="M194.012 134.559V142.026H209.844C211.137 142.026 212.189 140.974 212.189 139.681V137.545C212.189 136.52 212.024 135.513 211.707 134.559H194.012V134.559Z"
          fill="#FFE645"
        />
        <path
          d="M169.996 113.502C169.891 113.502 169.785 113.491 169.679 113.468C168.873 113.294 168.36 112.499 168.534 111.692C169.73 106.15 172.784 101.059 177.132 97.357C177.76 96.822 178.703 96.8978 179.238 97.5259C179.773 98.1543 179.697 99.0971 179.069 99.6321C175.218 102.911 172.514 107.418 171.455 112.323C171.304 113.023 170.684 113.502 169.996 113.502Z"
          fill="#FF8B6E"
        />
        <path
          d="M218.005 113.502C217.316 113.502 216.697 113.023 216.546 112.323C215.487 107.418 212.783 102.911 208.932 99.6322C208.303 99.0972 208.228 98.1543 208.763 97.526C209.298 96.8977 210.241 96.822 210.869 97.3571C215.217 101.059 218.27 106.15 219.467 111.692C219.641 112.499 219.128 113.294 218.321 113.468C218.215 113.491 218.109 113.502 218.005 113.502Z"
          fill="#FF674F"
        />
        <path
          d="M175.742 115.25C175.651 115.25 175.558 115.241 175.464 115.224C174.653 115.071 174.12 114.29 174.272 113.479C175.092 109.116 177.392 105.085 180.747 102.129C181.367 101.584 182.311 101.644 182.856 102.263C183.401 102.882 183.342 103.826 182.722 104.372C179.865 106.889 177.906 110.319 177.209 114.031C177.074 114.749 176.447 115.25 175.742 115.25Z"
          fill="#FF8B6E"
        />
        <path
          d="M212.26 115.25C211.555 115.25 210.928 114.749 210.793 114.032C210.096 110.32 208.138 106.889 205.28 104.372C204.661 103.827 204.601 102.883 205.146 102.263C205.692 101.644 206.636 101.584 207.255 102.13C210.61 105.085 212.91 109.116 213.73 113.48C213.882 114.291 213.349 115.071 212.538 115.224C212.445 115.241 212.352 115.25 212.26 115.25Z"
          fill="#FF674F"
        />
      </g>
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_12640_41672"
        x1="144"
        y1="75"
        x2="144"
        y2="167"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#0B70E1" />
        <stop offset="0.71875" stopColor="#0E73E4" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_12640_41672"
        x1="79.4336"
        y1="36.9642"
        x2="208.569"
        y2="36.9642"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#03228F" />
        <stop offset="1" stopColor="#0E73E4" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_12640_41672"
        x1="103.242"
        y1="21.9288"
        x2="112.419"
        y2="21.9288"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#03228F" />
        <stop offset="1" stopColor="#0E73E4" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_12640_41672"
        x1="139.418"
        y1="21.9288"
        x2="148.595"
        y2="21.9288"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#03228F" />
        <stop offset="1" stopColor="#0E73E4" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_12640_41672"
        x1="172.063"
        y1="31.1497"
        x2="188.294"
        y2="31.1497"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#03228F" />
        <stop offset="1" stopColor="#0E73E4" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_12640_41672"
        x1="175.598"
        y1="21.9288"
        x2="184.775"
        y2="21.9288"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#03228F" />
        <stop offset="1" stopColor="#0E73E4" />
      </linearGradient>
      <clipPath id="clip0_12640_41672">
        <rect
          width="151"
          height="151"
          fill="white"
          transform="translate(68.5)"
        />
      </clipPath>
      <clipPath id="clip1_12640_41672">
        <rect
          width="51"
          height="51"
          fill="white"
          transform="translate(168.5 97)"
        />
      </clipPath>
    </defs>
  </svg>
);
